const setDisplayStates = (userObj) => {
  return {
    type: "SET_DISPLAY_STATES",
    payload: userObj,
  };
};

export default {
  setDisplayStates,
};
